import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../../store/userContextStore'
import { withLocalize } from "react-localize-redux";
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { newsActions } from '../../store/newsStore';

class LogoutComponent extends React.Component {
    componentDidMount = () => {
        if (this.props.authentication.isAuthorized) {
            this.props.resetSubjects();
            this.props.logoutNotifications();
            this.props.logout();
        }
    }

    render() {
        return "logout in progress"
    }
}
export default withLocalize(connect(
    state => state.userContext,
    dispatch => bindActionCreators(Object.assign({}, userContextActions, lastSubjectActions, newsActions), dispatch)
)(LogoutComponent));
